import { useQuery } from '@tanstack/react-query';
import { getSvgQrCodeForUrl } from '@services/qrCodeService';

export const useGetSvgQrCodeForUrl = (
  url: string,
  enabled: boolean = false,
) => {

  const { data, isFetching, refetch } = useQuery(
    ['getSvgQrCodeForUrl', url],
    () => getSvgQrCodeForUrl(url),
    {
      enabled,
    },
  );

  return { data, isFetching: isFetching, refetch };
};
